import type { BookshelfViewItem, ChapterRef, SourceBookDetail, SourceManifest } from "../api";
import type { DisplaySourceOption } from "./types";

export function getSourceName(sources: SourceManifest[], sourceId: string): string {
  return sources.find(source => source.id === sourceId)?.name ?? sourceId;
}

export function getCurrentChapterLabel(chapters: ChapterRef[], chapterId?: string, chapterIndex?: number): string | undefined {
  const chapter = chapterId ? chapters.find(item => item.id === chapterId) : undefined;
  return chapter?.title ?? (chapterIndex !== undefined ? chapters[chapterIndex]?.title : undefined);
}

export function createDisplaySourceOptions(item: BookshelfViewItem, sources: SourceManifest[]): DisplaySourceOption[] {
  return item.sources.map(source => ({
    id: `${source.sourceId}:${source.sourceBookId}`,
    sourceId: source.sourceId,
    sourceBookId: source.sourceBookId,
    name: getSourceName(sources, source.sourceId),
    latestChapterTitle: source.latestChapterTitle ?? "暂无最新章节",
    real: true,
  }));
}

export function createDisplayChapters(item: BookshelfViewItem): ChapterRef[] {
  if (!item.progress) return [];

  // 书架接口当前只保存阅读进度 没有完整目录时只展示真实存在的当前章节
  return [{
    id: item.progress.chapterId,
    sourceId: item.progress.sourceId ?? item.item.activeSourceId ?? item.sources[0]?.sourceId ?? "",
    bookSourceId: item.sources[0]?.sourceBookId ?? item.book.id,
    title: `第 ${item.progress.chapterIndex + 1} 章`,
    index: item.progress.chapterIndex,
  }];
}

export function mergeBookDetailIntoItem(
  item: BookshelfViewItem,
  detail: SourceBookDetail | null,
  sourceId?: string,
): BookshelfViewItem {
  if (!detail) return item;

  return {
    ...item,
    book: {
      ...item.book,
      title: detail.title || item.book.title,
      author: detail.author ?? item.book.author,
      coverUrl: detail.coverUrl ?? item.book.coverUrl,
      description: detail.description ?? item.book.description,
      tags: detail.tags ?? item.book.tags,
    },
    sources: item.sources.map(source => {
      if (source.sourceBookId !== detail.sourceBookId || (sourceId && source.sourceId !== sourceId)) return source;

      return {
        ...source,
        latestChapterTitle: detail.latestChapterTitle ?? source.latestChapterTitle,
        latestChapterAt: detail.latestChapterAt ?? source.latestChapterAt,
        chapterCount: detail.chapterCount ?? source.chapterCount,
      };
    }),
  };
}
